import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { Panel } from '../../../music24/components/primitives/Panel';
import { SMLButton } from '../../../music24/components/primitives/SMLButton';
import { AddArtistModal } from '../../../accountSelector/AddArtistModal';
import { artistSettingsMessages } from './artistSettingsMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Artist and SmartLinks parts; each part uses its own slice of it */
import styles from './artistSettings.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** A workspace with no artist yet (design artist-settings a2). */
const NoArtistCardComponent: React.FC = () => {
  const intl = useIntl();
  const [isOpen, setOpen] = useState(false);
  const open = useCallback(() => setOpen(true), []);
  const close = useCallback(() => setOpen(false), []);
  return (
    <Panel>
      <div className={styles.empty}>
        <span className={styles.emptyTitle}>{intl.formatMessage(artistSettingsMessages.noArtistTitle)}</span>
        <p className={styles.emptyText}>{intl.formatMessage(artistSettingsMessages.noArtistBody)}</p>
        <SMLButton variant="primary" onClick={open}>
          {intl.formatMessage(artistSettingsMessages.addArtist)}
        </SMLButton>
      </div>
      <AddArtistModal isOpen={isOpen} onClose={close} />
    </Panel>
  );
};

export const NoArtistCard = TypedMemo(NoArtistCardComponent);
